import { get } from '@api/request';

export async function fetchDeedProcessings(
  { deedService },
  authenticationToken,
  { pageSize, page, errorOnly, logType },
) {
  let url = `${deedService}/deedprocessing/logs?page=${page}&pageSize=${pageSize}`;
  if (errorOnly) {
    url += `&errorOnly=${errorOnly}`;
  }
  if (logType) {
    url += `&logType=${logType}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDeedProcessing(
  { deedService },
  authenticationToken,
  { logID },
) {
  const url = `${deedService}/deedprocessing/log/${logID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDeedProcessingErrors(
  { deedService },
  authenticationToken,
  { logID },
) {
  const url = `${deedService}/deedprocessing/log/${logID}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDeedProcessingLogtypes(
  { deedService },
  authenticationToken,
) {
  const url = `${deedService}/deedprocessing/logtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}
